﻿(function () {
  "use strict";

  angular.module("app").controller("CustomersController", CustomersController);

  CustomersController.$inject = ["$scope", "$rootScope", "request", "$timeout", "countriesService", "statesService", "deletedItemsService", "$filter", "constants", "$q", "auth", "$location", "modalService", "customerHelper", "fileSystemService", "scrollingHelper", "featureFlagService"];

  function CustomersController($scope, $rootScope, request, $timeout, countriesService, statesService, deletedItemsService, $filter, constants, $q, auth, $location, modalService, customerHelper, fileSystemService, scrollingHelper, featureFlagService) {
    var vm = this,
      scrollListId = "#scroll-list",
      customerVisitsDataTable;

    vm.constants = constants;

    vm.$onInit = onInit;

    vm.reactSidebarUpdateCounter = 0
    vm.showDeleted = false

    vm.customer;
    vm.schedulableProjects;
    vm.gallery;
    vm.typeFilter = angular.fromJson(localStorage.getItem("clientTypeFilter")) || { lead: { selected: true }, customer: { selected: true } };
    vm.salesUsers = { map: {}, users: [] };
    vm.salesLeads;
    vm.cannedResponses;
    vm.invite = { consult: null, addresses: [] };

    vm.beforeSelect = beforeSelect;
    vm.addCustomer = addCustomer;
    vm.selectCustomer = selectCustomer;
    vm.getCustomer = getCustomer;
    vm.updateCustomer = updateCustomer;
    vm.removeCustomer = removeCustomer;
    vm.restoreCustomer = restoreCustomer;
    vm.changeLeadCustomerSinceDate = changeLeadCustomerSinceDate;
    vm.updateLeadCustomerSinceDate = updateLeadCustomerSinceDate;

    vm.getPrimaryContacts = getPrimaryContacts;
    vm.getTags = getTags;
    vm.toggleRemove = toggleRemove;
    vm.addPhone = addPhone;
    vm.addEmail = addEmail;
    vm.addEditConsultModal = addEditConsultModal;
    vm.addEditSendConsult = addEditSendConsult;
    vm.sendInvites = sendInvites;
    vm.openPhotoGallery = openPhotoGallery;
    vm.selectPrimaryPhoto = selectPrimaryPhoto;
    vm.countries = countriesService.getAll();
    vm.states = [];
    vm.selectStates = false;
    vm.stateLabel = 'State / Province / Region';
    vm.reloadStates = reloadStates;

    // for linking / unlinking customer to QuickBooks
    vm.transformCustomerQboLinkData = transformCustomerQboLinkData;
    vm.customerLinkedInQbo = customerLinkedInQbo;
    vm.customerUnlinkedFromQbo = customerUnlinkedFromQbo;
    vm.createQboCustomer = createQboCustomer;

    // for importing customers from QuickBooks
    vm.importQbo = importQbo;

    vm.notificationDuration = 0
    vm.notificationType = ''
    vm.notificationMessage = ''
    vm.notificationOnClose = () => {
      vm.notificationMessage = ''
    }

    function showNotification(duration, type, message) {
      vm.notificationDuration = duration
      vm.notificationType = type
      vm.notificationMessage = message
      vm.notificationNonce = Math.random()
    }

    vm.emailBodyChanged = (value) => {
      if (vm.consult) {
        vm.consult.emailBody = value
        setTimeout(() => $scope.$apply(), 1)
      }
    }

    // send events to Intercom
    vm.intercom = {
      updateIntercomAddCustomer,
      updateIntercomImportCustomers
    }

    // for automatically updating the consult details texts by class or call
    vm.updateConsultAutoDetails = updateConsultAutoDetails;
    $('.auto-event-desc').change(function () {
      updateConsultEventDescription();
    });

    $('.auto-email-desc').change(function () {
      updateConsultEmailDescription();
    });

    $('.auto-summary').change(function () {
      updateConsultSummary();
    });

    $('.isCustomer_switch').change(function () {
      setCustomerLeadSince();
    });

    // used to hide tabs for page load performance
    vm.showTab = {
      tabInfo: true, tabProperties: false, tabWork: false, tabSchedule: false, tabVisits: false, tabAttachments: false, tabInvoicing: false
    };

    // used by tab PROPERTIES
    vm.getCustomerProperties = getCustomerProperties;

    // used by tab VISITS
    vm.getCustomerVisits = getCustomerVisits;

    // used by tab ATTACHMENTS
    vm.downloadICSFile = downloadICSFile;

    // used by tab INVOICING
    vm.getCustomerInvoices = getCustomerInvoices;

    // used to redirect user for property/consultation creation
    vm.urlNewForCustomer = urlNewForCustomer;

    $scope.$watch("vm.searchCustomers", function () {
      scrollingHelper.removeMessages();
      scrollingHelper.loadData(vm, scrollListId);
    });

    $scope.$watch("vm.consult.consultationDate", function () {
      if (vm.consult) {
        updateConsultAutoDetails();
      }
    });

    // used by customer create new button
    vm.toggleCreateNewModal = toggleCreateNewModal;
    vm.createNewSelectProperty = createNewSelectProperty;
    vm.createNewProjectSelectedProperty = createNewProjectSelectedProperty;
    vm.createNewType = {
      project: 'projects',
      estimate: 'estimates',
      serviceTicket: 'tickets',
      maintenanceContract: 'maintenance',
      property: 'property',
      consultation: 'consultation'
    }

    // used by push customer to QuickBooks when customer has multiple properties
    vm.initiatePushQboCustomerPromise = initiatePushQboCustomerPromise;
    vm.pushQboCustomerPropertySelected = pushQboCustomerPropertySelected;

    // checks if consult has at least one selected sales lead and sets the flag
    vm.checkConsultSalesLeadsSelected = checkConsultSalesLeadsSelected
    function checkConsultSalesLeadsSelected(consult) {
      vm.consult.isAnySalesLeadSelected = customerHelper.isAnySalesLeadSelected(consult)
    }

    function onInit() {
      vm.showDeleted = location.hash.indexOf('/deleted') > -1
      vm.sidebarAPI = vm.showDeleted ? "/customers/deleted" : "/customers";

      deletedItemsService.initAndSetTitlePage(vm, "Clients");

      // check if create new needs to be automatically triggered
      determineNewAutomatically();

      request.get($rootScope.apiEndpoint + '/users/sales').then(response => {
        vm.salesUsers.users = response.data;
        vm.salesUsers.users.forEach(u => vm.salesUsers.map[u.email] = u);
      }, () => {
        showNotification(5, 'Error', 'There was an error getting the list of sales users')
      });

      request.get($rootScope.apiEndpoint + '/salesleads').then(response => {
        vm.salesLeads = response.data;
      }, () => {
        showNotification(5, 'Error', 'There was an error getting the list of sales leads')
      });

      request.get($rootScope.apiEndpoint + "/cannedresponses").then(response => {
        vm.cannedResponses = response.data.filter(cr => cr.type == vm.constants.cannedResponseType.consultation);
      }, () => {
        showNotification(5, 'Error', "There was an error getting the list of canned responses")
      });

      angular.element(document).ready(function () {
        $('a[data-toggle="tab"]').on('click', function (e) {
          //sets the condition to display the tab to true when the tab is clicked
          showTabByDataTarget(e.target.getAttribute('data-target'));
          $(e.target).tab('show');
        });
      });

      bindAutocomplete();

      scrollingHelper.init(vm, scrollListId);
    }

    vm.showWorkTab = function () {
      vm.showTab.tabWork = true
      $('a[data-target="#tab-work"]').tab('show')
    }

    function reloadStates() {
      if (!vm.customer)
        return;

      vm.customer.state = '';
      vm.selectStates = false;
      vm.stateLabel = 'State / Province / Region';
      vm.states = [];

      loadStates();
    }

    function loadStates() {
      var country = vm.countries.filter(c => c.code === vm.customer.countryCode);
      if (country.length) {
        country = country[0];
        vm.selectStates = country.hasStates;
        if (country.hasStates) {
          vm.stateLabel = country.stateLabel;
          vm.states = statesService.getForCountry(country.code)
        }
        else {
          vm.stateLabel = 'State / Province / Region';
        }
      }
    }

    function beforeSelect(customer) {
      if ($scope.customerForm?.$dirty) {
        if (!confirm("This customer has been edited.\n\nDiscard your changes and select a different customer?")) {
          return false;
        }
      }

      return true
    }

    function addCustomer(newIsCustomer = false) {
      //todo: default country from tenant.
      vm.customer = {
        id: 0, isActive: true, isCustomer: newIsCustomer, displayName: 'New Customer', countryCode: '', state: '', selectedSalesLeads: {}, phones: [], emails: [], tagsArray: [], properties: 0
      };

      // enable automatically generate property toggle
      vm.createNewPropertyAutomatically = true;

      reloadStates();
      $("#company").focus();
      $scope.customerForm.$setPristine();
      $scope.$apply();
    }

    function selectCustomer(customer) {
      getCustomer(customer.id);
      if ($scope.customerForm) {
        $scope.customerForm.$setPristine();
      }

      // reset tabs when new customer is selected
      resetTabs();
    }

    function getCustomer(id) {
      return request.get($rootScope.apiEndpoint + vm.sidebarAPI + "/" + id).then(function (response) {
        vm.customer = response.data;
        // if customer has no property, display the property auto generation toggle
        vm.createNewPropertyAutomatically = vm.customer.properties == 0 ? true : false

        if (vm.customer.salesLead) {
          vm.customer.selectedSalesLeads = {};
          angular.forEach(vm.customer.salesLead.split(", "), function (value) {
            vm.customer.selectedSalesLeads[value] = true;
          });
        }

        loadStates();
      }, function () {
        showNotification(5, 'Error', "There was an error loading the customer.")
      });
    }

    function getPrimaryContacts(type) {
      var contacts = [];

      if (!vm.customer || vm.customer[type].length === 0) return;

      contacts = vm.customer[type].filter(function (c) { return c.isPrimary; });

      if (contacts.length === 0) {
        contacts.push(vm.customer[type][0]);
      }

      return contacts;
    }

    function getTags(q) {
      return request.get($rootScope.apiEndpoint + "/customers/tags?search=" + q);
    }

    function toggleRemove(element) {
      element.removed = !element.removed;
      $scope.customerForm.$setDirty();
    }

    function addPhone() {
      vm.customer.phones.push({ id: 0, customerId: vm.customer.id, type: 2 });
      $timeout(function () {
        $(".phone-contact:last select").focus();
      });
    }

    function addEmail() {
      vm.customer.emails.push({ id: 0, customerId: vm.customer.id });
      $timeout(function () {
        $(".email-contact:last input[type=email]").focus();
      });
    }

    function addEditConsultModal(consult) {
      if (consult) {
        vm.consult = Object.assign({}, consult);
        consult.editing = true;
      } else {
        vm.consult = { id: 0, customerId: vm.customer.id, consultationDate: null, salesLead: vm.customer.salesLead, addOnSave: true };
      }

      vm.consult.consultationDate = !vm.consult.consultationDate ? "" : moment(vm.consult.consultationDate, [moment.ISO_8601, 'M/DD/YYYY h:mm A']).format("L LT");
      if (vm.consult.salesLead) {
        vm.consult.selectedSalesLeads = {};
        vm.consult.salesLead.split(', ').forEach(l => vm.consult.selectedSalesLeads[l] = true);
      }

      checkConsultSalesLeadsSelected(vm.consult)

      request.get($rootScope.apiEndpoint + `/customers/${vm.customer.id}/consultation-projects`).then((response) => {
        vm.schedulableProjects = response.data;
        $('#schedule-consultation').modal();
      }, (e) => {
        showNotification(5, 'Error', "There was an error")
      });
    }

    function addEditSendConsult(send, event) {
      if (vm.consult.selectedSalesLeads) {
        vm.consult.salesLead = Object.keys(vm.consult.selectedSalesLeads)
          .filter(l => vm.consult.selectedSalesLeads[l])
          .join(', ');
      } else {
        vm.consult.salesLead = null;
      }

      if (vm.consult.salesLead == "") {
        vm.consult.isAnySalesLeadSelected = false;
      }
      else if (!vm.isSavingConsultation) {
        vm.isSavingConsultation = true
        request.post($rootScope.apiEndpoint + '/consultations/addEditConsultation', vm.consult)
          .then(response => {
            vm.isSavingConsultation = false
            if (send == true) {
              if (event) {
                sendInvites(event, response.data);
              }
              else {
                showNotification(5, 'Error', "There was an error sending your invites.")
              }
            }
          }, e => {
            console.log(e);
            vm.isSavingConsultation = false
            showNotification(5, 'Error', "There was an error saving the consultation")
          }).then(() => {
            getCustomer(vm.customer.id);
            $('#schedule-consultation').modal('hide');
          });
      }
    }

    function updateConsultAutoDetails() {
      updateConsultSummary();
      updateConsultEmailDescription();
      updateConsultEventDescription();
    }

    function updateConsultEventDescription() {
      // auto complete Event Description (used for calendar event description)
      let organizer = $('#organizerEmail :selected').text(),
        project = $('#consultProject :selected').text(),
        dt = vm.consult
          ? moment(vm.consult.consultationDate, 'M/DD/YYYY h:mm A')
          : null,
        description = '',
        customAddress = [vm.customer.address1, vm.customer.city, vm.customer.state, vm.customer.zip].filter(Boolean).join(', '),
        salesLeadsArray = (vm.consult && vm.consult.selectedSalesLeads) ? Object.keys(vm.consult.selectedSalesLeads).filter(l => vm.consult.selectedSalesLeads[l]).join(', ') : [];

      if (!vm.consult) {
        return
      }

      if (vm.consult.cannedResponse && vm.cannedResponses) {
        const cannedResponse = vm.cannedResponses.find(c => c.id.toString() === vm.consult.cannedResponse);
        if (cannedResponse) {
          description += cannedResponse.eventDescription + '\n\n';
        }
      }

      description += 'Your ';
      description += project ? `${project} ` : '';
      description += 'consultation has been scheduled';
      description += organizer ? ` with ${organizer}` : '';
      description += dt.isValid() ? ` for ${dt.format('dddd, MMMM Do')} at ${dt.format('h:mm A')}.` : '.';
      description += `\n\n Client Name: ${vm.customer.displayName}`;
      description += vm.customer.phones.length ? `\n Phone Number(s): ${vm.customer.phones.map(function (p) { return p.number }).join('; ')}` : '';
      description += vm.customer.emails.length ? `\n Email(s): ${vm.customer.emails.map(function (p) { return p.address }).join('; ')}` : '';
      description += customAddress ? `\n Address: ${customAddress}` : '';
      description += vm.consult?.selectedSalesLeads ? `\n Sales leads: ${salesLeadsArray}` : '';

      vm.consult.description = description;
    }

    function updateConsultEmailDescription() {
      // auto complete Email Description (used for Email Body)
      let salesPerson = $('#organizerEmail :selected').text(),
        body = '';

      body = `<p>Hi ${escapeHtml(vm.customer.displayName)},</p>`;

      // used canned response template [if any]
      if (vm.consult.cannedResponse) {
        body += vm.cannedResponses.find(c => c.id.toString() === vm.consult.cannedResponse).emailBody;
      } else {
        body += '<p>Thanks for reaching out to us regarding your project! We’re excited to kick this off and explore what we can do to achieve your vision.</p>';
        body += `<p>Please have all decision makers present for the meeting. We always recommend to take some time before the meeting, think about all the things that you want us to know, and be ready to discuss those questions or options during the consultation. Our goal is to help you achieve your vision and go beyond your expectations!</p>`;
        body += '<p>Looking forward to it!</p>';
        body += `<p>Regards, <br/> ${escapeHtml(salesPerson)} </p>`;
        body += '<p>If you discover you need to reschedule for some reason, please give us as much notice as possible prior to the scheduled meeting.</p>';
      }

      vm.consult.emailBody = body;
    }

    function updateConsultSummary() {
      // auto complete Summary (used for invitation Email Subject)
      // use canned response template [if any]
      if (vm.consult.cannedResponse && vm.cannedResponses) {
        vm.consult.summary = vm.cannedResponses.find(c => c.id.toString() === vm.consult.cannedResponse).emailSubject
      } else {
        vm.consult.summary = vm.consult.projectId ? `${$('#consultProject :selected').text()} Consultation` : 'Scheduled Project Consultation';
      }
    }

    function sendInvites(event, consult, readyToSend) {
      event.stopPropagation();

      if (readyToSend) {
        const icon = $('i.fas:eq(1)', event.target);
        let emailAddresses = { addresses: [], replyToAddresses: [] };
        emailAddresses = {
          addresses: vm.invite.addresses.filter(e => e.selected).map(e => e.address),
          replyToAddresses: vm.invite.replyToAddresses.filter(e => e.selected).map(e => e.address)
        };

        icon.addClass('fa-spinner fa-spin');

        request.post($rootScope.apiEndpoint + `/customers/${vm.customer.id}/sendconsultationinvites/${vm.invite.consult.id}`, emailAddresses)
          .then(response => {
            showNotification(5, 'Success', 'Your invites have been sent to you and this customer.')
          }, e => {
            console.log(e);
            showNotification(5, 'Error', 'There was an error sending your invites. Please try again later.')
          }).then(() => {
            icon.removeClass('fa-spinner fa-spin');
            $('#schedule-consultation-send').modal('hide');
          });

        return;
      }

      vm.invite.consult = consult;
      vm.invite.addresses = [{ address: vm.salesUsers.map[consult.organizerEmail].email, selected: true }];
      vm.customer.emails.forEach(e => vm.invite.addresses.push({ address: e.address, selected: e.isPrimary }));
      vm.invite.replyToAddresses = [{ address: vm.salesUsers.map[consult.organizerEmail].email, selected: true }];
      vm.customer.emails.forEach(e => vm.invite.replyToAddresses.push({ address: e.address, selected: e.isPrimary }));
      if (consult.createdBy) {
        vm.invite.replyToAddresses.push({ address: consult.createdBy, selected: false });
      }
      $('#schedule-consultation-send').modal();
    }

    function updateCustomer() {
      if (!vm.customer.selectedSalesLeads || Object.keys(vm.customer.selectedSalesLeads).length === 0) {
        vm.customer.salesLead = null;
      } else {
        vm.customer.salesLead = Object.keys(vm.customer.selectedSalesLeads).filter(function (k) { return vm.customer.selectedSalesLeads[k] === true; }).join(", ");
      }
      vm.customer.tags = vm.customer.tagsArray.map(function (t) { return t.text; }).join(", ");

      if (vm.customerSinceAtSwitch) {
        vm.customer.customerSince = vm.customerSinceAtSwitch;
      }
      if (vm.leadSinceAtSwitch) {
        vm.customer.leadSince = vm.leadSinceAtSwitch;
      }

      var updateCustomerUrl = "/customers";
      if (vm.createNewPropertyAutomatically) updateCustomerUrl += `?createFirstPropertyAutomatically=true`
      request.post($rootScope.apiEndpoint + updateCustomerUrl, vm.customer).then(function (response) {
        vm.intercom.updateIntercomAddCustomer();

        var savedCustomerId = response.data.id;

        $scope.customerForm.$setPristine();
        vm.reactSidebarUpdateCounter++;
        vm.reactSidebarNewCustomerId = savedCustomerId;

        return getCustomer(savedCustomerId).then(function () {
          vm.createNewPropertyAutomatically = false;

          if (vm.showTab.tabProperties) {
            getCustomerProperties();
          }
        });
      }, function (e) {
        console.log(e);
        showNotification(5, 'Error', "There was an error saving this customer")
      });
    }

    function updateIntercomAddCustomer() {
      var metadata = {
        customer_name: `${vm.customer.firstName} ${vm.customer.lastName}`,
        customer_email: vm.customer.emails[0] ? vm.customer.emails[0].address : 'undefined',
        customer_phone: vm.customer.phones[0] ? vm.customer.phones[0].number : 'undefined',
        customer_address: vm.customer.address1,
        customer_city: vm.customer.city,
        customer_state: vm.customer.state
      };

      if (vm.customer.id == 0) {
        window.Intercom("trackEvent", "created-customer", metadata);
      }
    }

    function removeCustomer() {
      if (vm.customer.projects > 0) {
        showNotification(5, 'Error', "This customer cannot be removed because there are associated jobs. To remove this customer, please first remove the jobs.")
        return
      }

      modalService.confirm("This cannot be undone and will remove all information regarding this customer and properties.", "Remove this customer?")
        .then(function (result) {
          if (result) {
            request.delete($rootScope.apiEndpoint + "/customers/" + vm.customer.id).then(function (response) {
              vm.customer = undefined;
              vm.reactSidebarUpdateCounter++
            }, function (e) {
              console.log(e);
              const errorMessage = (e.data && e.data.message) ? e.data.message : "There was an error removing this customer."
              vm.reactSidebarUpdateCounter++
              showNotification(5, 'Error', errorMessage)
            });
          }
        });
    }

    function restoreCustomer() {
      modalService.confirm("Restore this customer?", "Restore")
        .then(function (result) {
          if (result) {
            request.post($rootScope.apiEndpoint + "/customers/restore/" + vm.customer.id).then(function (response) {
              vm.customer = undefined;
              vm.reactSidebarUpdateCounter++

              showNotification(5, 'Success', "The customer has been successfully restored!")
            }, function (e) {
              console.log(e);
              vm.reactSidebarUpdateCounter++
              showNotification(5, 'Error', "There was an error restoring this customer")
            });
          }
        });
    }

    function changeLeadCustomerSinceDate(sinceDate, standardSiceDate, fieldName, type) {
      vm.override = {};
      vm.override.date = sinceDate ? moment(sinceDate).format('MM/DD/YYYY') : "";
      vm.override.standardSiceDate = standardSiceDate ? moment(standardSiceDate).format('MM/DD/YYYY') : "";
      vm.override.type = type;
      vm.override.fieldName = fieldName;
      $("#customer-lead-since-date").modal();
    }

    function updateLeadCustomerSinceDate(reset) {
      if (reset) {
        vm.override.date = null;
      }

      vm.customer[vm.override.fieldName] = vm.override.date ? moment(vm.override.date).format('ll') : null;
      vm.override.type = null;
      vm.override.date = null;
      vm.override.fieldName = null;
      $scope.customerForm.$setDirty();
    }

    function setCustomerLeadSince() {
      //used to set customerSince or LeadSince date at switch
      vm.leadSinceAtSwitch = null;
      vm.customerSinceAtSwitch = null;
      var dateNow = moment(Date.now()).format('ll');
      if (vm.customer.isCustomer && !vm.customer.customerSince && !vm.customer.customCustomerSince) {
        vm.customerSinceAtSwitch = dateNow;
      }
      else if (!vm.customer.isCustomer && !vm.customer.leadSince && !vm.customer.customLeadSince) {
        vm.leadSinceAtSwitch = dateNow;
      }
    }

    function openPhotoGallery() {
      vm.gallery = [];

      request.get($rootScope.apiEndpoint + "/attachments/photos/" + vm.customer.id).then(function (response) {
        vm.gallery = response.data;
      }, function (e) {
        showNotification(5, 'Error', 'There was an error getting the image attachments for this customer')
      });
    }

    function selectPrimaryPhoto(item) {
      vm.customer.primaryPhotoId = item ? item.id : null;
      $scope.customerForm.$setDirty();
    }

    function bindAutocomplete() {
      if (typeof google === "undefined"
        || typeof google.maps === "undefined"
        || typeof google.maps.places === "undefined") {

        // google maps api is loaded aync, so we must ensure that api is loaded.
        $timeout(bindAutocomplete, 100);

        return;
      }

      var input = document.getElementById("address1");

      var autocomplete = new google.maps.places.Autocomplete(input);

      // set the types returned by the autocomplete
      autocomplete.setTypes(['address']);

      // Set the data fields to return when the user selects a place.
      autocomplete.setFields(['address_components', 'geometry']);

      var getAddressComponent = function (components, type, longName) {
        longName = longName || false;

        if (components === undefined || components === null) {
          return '';
        }

        var component = components.filter(c => c.types.indexOf(type) >= 0);

        if (component.length === 0)
          return '';

        component = component[0];

        return longName ? component.long_name : component.short_name;
      };

      autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace();
        var addressComponents = place.address_components;

        // update address fields

        vm.customer.address1 = (getAddressComponent(addressComponents, "street_number", true) + ' ' + getAddressComponent(addressComponents, "route", true)).trim();
        vm.customer.city = getAddressComponent(addressComponents, "locality", true) || getAddressComponent(addressComponents, "sublocality", true);
        vm.customer.zip = getAddressComponent(addressComponents, "postal_code");
        vm.customer.county = getAddressComponent(addressComponents, "administrative_area_level_2", true);
        vm.customer.countryCode = getAddressComponent(addressComponents, "country");
        vm.customer.location = place.geometry && place.geometry.location ? {
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng()
        } : undefined;

        reloadStates();
        var useStateLongName = vm.countries.filter(c => c.code === vm.customer.countryCode && c.hasStates).length === 0;
        vm.customer.state = getAddressComponent(addressComponents, "administrative_area_level_1", useStateLongName);

        $scope.$apply();
      });
    }

    // function used by the link-qbo-entity component
    // to transform the data which is posted to the update endpoint [to update the qboId property in the db]
    function transformCustomerQboLinkData(data) {
      return { id: vm.customer.id, qboId: data.id, qboDisplayName: data.displayName };
    }

    // function called after the customer has been successfully linked from the link-qbo-entity component
    // to update the view model
    function customerLinkedInQbo(data) {
      vm.customer.qboId = data.qboId;
      vm.customer.qboDisplayName = data.qboDisplayName;
    }

    // function called after the customer has been successfully unlinked from the link-qbo-entity component
    // to update the view model
    function customerUnlinkedFromQbo() {
      vm.customer.qboId = null;
      vm.customer.qboDisplayName = null;
    }

    // function called when importing customer(s) from QuickBooks
    async function importQbo(data) {

      // send event to Intercom
      window.Intercom("trackEvent", "imported-customers");

      await request.post($rootScope.apiEndpoint + '/customers/qbo/import', data).then(function (response) {

        vm.reactSidebarUpdateCounter++
        showNotification(5, 'Success', response.data)

        vm.intercom.updateIntercomImportCustomers(response.data, true);

      }, error => {
        console.log(error);

        vm.reactSidebarUpdateCounter++
        vm.intercom.updateIntercomImportCustomers(error.data.message, false);

        showNotification(5, 'Error', response.data)
      });
    }

    function updateIntercomImportCustomers(message, success) {
      let metadata = {
        message: message,
        success: success
      };
      window.Intercom("trackEvent", "imported-customers", metadata);
    }

    // #region TABS COMMON

    function showTabByDataTarget(dataTarget) {
      if (dataTarget) {
        vm.showTab[convertToCamelCase(dataTarget.substring(1))] = true;
        $scope.$apply();
      }
    }

    function convertToCamelCase(stringToConvert) {
      //converts string like this "report-selection-modal" to a string like this "reportSelectionModal"
      var arrString = stringToConvert.split("-");
      var result = arrString[0];
      for (var i = 1; i < arrString.length; i++) {
        result = result.concat(arrString[i].charAt(0).toUpperCase() + arrString[i].substring(1));
      }
      return result;
    }

    /* used to reset tabs when customer is changed
     */
    function resetTabs() {
      // destroy customer projects data table
      if (customerVisitsDataTable) {
        customerVisitsDataTable.destroy();
        $("#customer-visits-items tbody").empty();
        customerVisitsDataTable = null;
      }

      // set active tab to Info tab
      $('a[aria-controls="tab-info"]').tab('show');
      $("#tab-info").addClass("in active");

      // reset all other tabs to false
      for (var prop in vm.showTab) {
        if (prop != "tabInfo")
          vm.showTab[prop] = false;
      }
    }

    // #endregion

    // #region TAB PROPERTIES

    /* used to retrieve customer properties when the Properties tab is selected
     */
    function getCustomerProperties() {
      request.get($rootScope.apiEndpoint + "/customers/" + vm.customer.id + "/properties").then(function (response) {
        vm.customer.retrievedProperties = response.data;
      });
    }

    // #endregion

    /* used to trigger the new customer form automatically and clear hash from url
     * triggered when the user contains the 'new' hash
     */
    function determineNewAutomatically() {
      if (location.hash.indexOf('#newProperty') > -1) {
        // open select customer modal
        determineNewAction('property');
        return;
      }

      if (location.hash.indexOf('#newConsultation') > -1) {
        // open select customer modal
        determineNewAction('consultation');
        return;
      }

      if (location.hash.indexOf('#newCustomer') > -1) {
        // add new Customer
        determineNewAction('customer');
      }

      if (location.hash.indexOf('#newLead') > -1) {
        // add new LEAD customer
        determineNewAction('lead');
      }
    }

    /* used by Schedule tab calendar view, to prepare event view on calendar
     */
    function getCalendarEventHtml(event) {
      // the calendar event element rendered on the calendar view

      var html = "";

      if (event.consultation) {
        // prepare consultation event HTML
        html += 'Consultation';

        html += '<small class="customer">' + escapeHtml(event.consultation.customer.displayName) + '</small>';

      }
      else {
        // prepare project/route event HTML
        if (event.project.schedulingNotes) {
          html += '<i class="fas fa-fw fa-calendar-edit scheduling-notes-icon"></i>'
        }

        html += escapeHtml(event.project.name);

        html += '<small class="hours"><i class="fal fa-fw fa-stopwatch"></i> ' + event.project.hours + ' mh';
        if (event.manhourDays !== null)
          html += ' / ' + escapeHtml(event.manhourDays) + ' days'
        html += '</small>';

        html += '<small class="customer">' + escapeHtml(event.project.customer.displayName) + '</small>';

        if (event.route)
          html += '<small class="route-name">' + escapeHtml(event.route.name) + '</small>';
      }

      return html;
    }

    // #endregion

    // #region TAB VISITS

    /* used to retrieve customer visits when the Visits tab is selected
    */

    function escapeHtml(unsafe) {
      if (typeof unsafe !== 'string') return unsafe;
      if (unsafe.length < 1) return unsafe;
      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;")
        .replace(/'/g, "&#039;")
    }

    function getCustomerVisits() {

      // only initialize once when switching tabs for same customer
      if (!$.fn.DataTable.isDataTable('#customer-visits-items')) {
        customerVisitsDataTable = $("#customer-visits-items").DataTable({
          pageLength: 25,
          dom: "tipr",
          ajax: { url: $rootScope.apiEndpoint + `/v2/time/cards/dynamic?customerId=${vm.customer.id}`, type: "post", headers: auth.headers() },
          serverSide: true,
          processing: true,
          language: {
            processing: '<i class="fa fa-gap fa-spin fa-spinner"></i>loading visits'
          },
          columns: [
            { data: "id", class: "hidden" },
            {
              data: "date",
              render: function (value) {
                return $filter("date")(value, "medium");
              }
            },
            {
              data: "project.type",
              render: function (value) {
                switch (value) {
                  case 0:
                    return "Template";
                  case 1:
                    return "Project";
                  case 2:
                    return "Ticket"
                  case 3:
                    return "Maintenance"
                }
              }
            },
            { data: "project.division.name", defaultContent: "", render: escapeHtml },
            { data: "createdByEmail", render: escapeHtml },
            { data: "project.name", class: "no-wrap ellipsis", render: escapeHtml }
          ],
          order: [[1, "desc"]]
        });
      }
    }

    // #endregion

    // #region TAB INVOICING

    /* used to retrieve customer invoices when the Invoicing tab is selected
     */
    function getCustomerInvoices() {
      request.get($rootScope.apiEndpoint + `/invoices/customer/${vm.customer.id}`).then(function (response) {
        vm.customer.retrievedInvoices = response.data;
      });
    }

    // #endregion

    /* used when passing #new parameter to select customer for appropriate action
     */
    function determineNewAction(modalType) {
      // clear url of the 'new' hash
      $location.hash('')

      // initiate new form by type
      if (modalType == 'lead') {
        $timeout(function () {
          addCustomer();
        });
      }
      else if (modalType == 'customer') {
        $timeout(function () {
          addCustomer(true);
        });
      }
      else {
        vm.urlNewModalType = modalType;
        $timeout(function () {
          $("#select-customer-url-modal").modal();
          scrollingHelper.resetSearch(vm);
          scrollingHelper.loadData(vm, scrollListId);
        });
      }
    }

    /* used when passing #new parameter
     * triggering appropiate action after customer was selected 
     */
    function urlNewForCustomer() {
      // if add new consultation, pop up modal
      if (vm.urlNewModalType == 'consultation') {
        getCustomer(vm.selectedUrlCustomer.id).then(function () {
          $location.url('customers#!#' + vm.selectedUrlCustomer.url)

          $timeout(function () { addEditConsultModal(); }, 500);
        });
      }

      // if add new property, redirect to properties page
      if (vm.urlNewModalType == 'property')
        $location.url('customers/' + vm.selectedUrlCustomer.url + '/properties#new');
    }

    /* used when user clicks on '+ New' button from the Customer Profile Page
     */
    function toggleCreateNewModal() {
      // preselect first property is customer has more than 1
      if (vm.customer.properties > 1)
        vm.createNewSelectedProperty = vm.customer.propertyList[0];

      // hide select property button for now
      vm.showCreateNewSelectPropertyBtn = false;

      $('a[data-target="#tab-select-type"]').tab('show');
      $("#create-new-modal").modal();
    }

    function createNewSelectProperty(selectedType) {

      // consultation or property types can be created regardless of customer having any properties or not at all
      // if customer has only 1 property, automatically select the only property and redirect to creation
      // if customer has more than 1 property, switch tab and let customer select property

      switch (selectedType) {
        case vm.createNewType.property:
          $("#create-new-modal").modal('hide');
          $location.url('customers/' + vm.customer.url + '/properties#new');
          break;
        case vm.createNewType.consultation:
          $("#create-new-modal").modal('hide');
          addEditConsultModal();
          break;
        default:
          vm.customer.properties <= 1 ? createNewProject(selectedType) : switchCreateNewTab(selectedType);
          break;
      }
    }

    function switchCreateNewTab(selectedType) {
      // switch to properties tab and let customer select
      vm.showCreateNewSelectPropertyBtn = true;
      vm.createNewSelectedType = selectedType;
      $('a[data-target="#tab-select-property"]').tab('show');
    }

    function createNewProjectSelectedProperty() {
      createNewProject(vm.createNewSelectedType, vm.createNewSelectedProperty);
    }

    /* used by the customer create new project button
     */
    function createNewProject(type, selectedProperty) {
      var newProject = { customerId: vm.customer.id, propertyId: vm.customer.propertyList[0].id };

      if (selectedProperty !== undefined)
        newProject.propertyId = selectedProperty.id;

      switch (type) {
        case vm.createNewType.project:
          newProject.timecardInternalNotesInputMode = vm.constants.timecardInternalNotesInputMode.showButNotRequireInput;
          newProject.timecardClientNotesInputMode = vm.constants.timecardClientNotesInputMode.showAndNotificationOffByDefault;
          break;
        case vm.createNewType.serviceTicket:
          newProject.timecardInternalNotesInputMode = vm.constants.timecardInternalNotesInputMode.showButNotRequireInput;
          newProject.timecardClientNotesInputMode = vm.constants.timecardClientNotesInputMode.showAndNotificationOnByDefault; // Client notes in mobile app: Show & notification on by default
          break;
        case vm.createNewType.maintenanceContract:
          newProject.timecardInternalNotesInputMode = vm.constants.timecardInternalNotesInputMode.showButNotRequireInput;
          newProject.timecardClientNotesInputMode = vm.constants.timecardClientNotesInputMode.showAndNotificationOnByDefault; // Client notes in mobile app: Show & notification on by default
          break;
      }

      request.post($rootScope.apiEndpoint + `/${type}/create`, newProject).then(
        function (response) {
          $("#create-new-modal").modal('hide');
          $location.url(`${type}/` + response.data.url);
        }, function (ex) {
          showNotification(5, 'Error', "There was an error creating this project")
        });
    }

    /* used when the QuickBooks linking pop is opened
     * initiates the linking promise to the QuickBooks component
     */
    function initiatePushQboCustomerPromise() {
      vm.pushQboCustomerDefer = $q.defer();
    }

    /* used when pushing customer to QBO, ONLY IF the customer has multiple properties
     * this is used to allow user to select target property
     */
    function pushQboCustomerPropertySelected() {
      vm.isPushQboCustomerPropertySelected = true;
      createQboCustomer();
    }

    /* function called when creating QuickBooks customer from Synked customer
     */
    function createQboCustomer() {
      var apiUrl = `/quickbooks/customer?id=${vm.customer.id}`;

      // if customer has more properties, override method to first select the target property
      if (vm.customer.properties > 1) {
        if (!vm.isPushQboCustomerPropertySelected) {
          $(".modal").modal("hide");
          vm.selectedPushQboCustomerProperty = vm.customer.propertyList[0];
          $("#select-property-qbo-create-customer").modal();

          // return unresolved promise, to allow user select the customer property
          return vm.pushQboCustomerDefer.promise;
        }
        else {
          // if target property was selected, add to apiUrl as param
          apiUrl += vm.selectedPushQboCustomerProperty ? `&selectedPropertyId=${vm.selectedPushQboCustomerProperty.id}` : '';
        }
      }

      // finally, push the customer to QBO
      request.post($rootScope.apiEndpoint + apiUrl).then(function (result) {
        vm.customer.qboId = result.data.entity.id;
        vm.customer.qboDisplayName = result.data.entity.displayName;
        vm.isPushQboCustomerPropertySelected = false;
        vm.pushQboCustomerDefer.resolve({ id: vm.customer.id, qboId: result.data.entity.id, qboDisplayName: result.data.entity.displayName });

      }, function (e) {
        vm.isPushQboCustomerPropertySelected = false;
        vm.pushQboCustomerDefer.reject(e);
      });

      if (vm.pushQboCustomerDefer) {
        return vm.pushQboCustomerDefer.promise
      } else {
        return
      }
    }

    function downloadICSFile(id) {
      var apiMethod = `/calendar/consultations/${id}`;

      request.get($rootScope.apiEndpoint + apiMethod).then(function (response) {
        fileSystemService.saveIcs(response.dta, 'calendar.ics')
      });
    }

    vm.attachmentUploadVisible = false

    vm.showAttachmentUpload = function showAttachmentUpload() {
      vm.attachmentUploadVisible = true
    }

    vm.onAttachmentUploadClose = function onAttachmentUploadClose() {
      vm.attachmentUploadVisible = false
      setTimeout(() => $scope.$apply(), 1)
    }
  }

})();
